/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChevronLast = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m7 18 6-6-6-6" }],
    ["path", { d: "M17 6v12" }]
  ]
];

export { ChevronLast as default };
//# sourceMappingURL=chevron-last.js.map
